import React from "react";
import PropTypes from "prop-types";
import { LockOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { openLoginModal } from "../../store/reducers/authSlice";
import { currentSession } from "../../utils/session";

/**
 * Vrai si un utilisateur est connecté. S'abonne au store d'authentification pour que la page
 * se redessine à la connexion (fenêtre de connexion globale), la session restant lue du JWT.
 */
export const useLoggedIn = () => {
    useSelector((state) => state.auth?.token);
    return !!currentSession();
};

/**
 * Pages entreprise (producteurs, spéculateurs, négociants) : un visiteur non connecté ne voit
 * clairement que la première offre ; les suivantes sont floutées et invitent à se connecter.
 */
export const isLocked = (loggedIn, page, index) => !loggedIn && (page > 1 || index > 0);

const overlayStyle = {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    border: "none",
    borderRadius: 8,
    background: "rgba(255, 255, 255, 0.35)",
    color: "#1f3d1f",
    fontWeight: 600,
    fontSize: 15,
    cursor: "pointer",
};

// React 18 ne connaît pas encore la prop `inert` : posée à la main, elle retire la carte floutée
// du clavier et des lecteurs d'écran.
const makeInert = (element) => element?.setAttribute("inert", "");

/** Floute la carte et la recouvre d'un bouton « Connectez-vous pour voir » quand `locked`. */
const LoginToUnlock = ({ locked, children }) => {
    const dispatch = useDispatch();
    if (!locked) return children;
    return (
        <div style={{ position: "relative", height: "100%" }}>
            <div
                ref={makeInert}
                aria-hidden="true"
                data-testid="locked-offer"
                style={{ filter: "blur(7px)", pointerEvents: "none", userSelect: "none", height: "100%" }}
            >
                {children}
            </div>
            <button type="button" style={overlayStyle} onClick={() => dispatch(openLoginModal())}>
                <LockOutlined style={{ fontSize: 28 }} />
                Connectez-vous pour voir
            </button>
        </div>
    );
};

LoginToUnlock.propTypes = {
    locked: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

export default LoginToUnlock;
